export const SHOW_LOADER = 'SHOW_LOADER'
export const HIDE_LOADER = 'HIDE_LOADER'
export const HAVE_UNREAD_MESSAGES = 'HAVE_UNREAD_MESSAGES'
export const CHANGE_PAGE_LINK_FROM_HEADER = 'CHANGE_PAGE_LINK_FROM_HEADER'
export const GIGYA_ACTION = 'GIGYA_ACTION'
export const SHOW_SEARCH_MOBILE = 'SHOW_SEARCH_MOBILE'
export const IS_PAGE_LOAD = 'IS_PAGE_LOAD'
export const SHOW_SURVEY = 'SHOW_SURVEY'
export const SHOW_POPOVER = 'SHOW_POPOVER'
export const MOBILE_FULL_MODE = 'MOBILE_FULL_MODE'
export const HAVE_NEW_MESSAGE = 'HAVE_NEW_MESSAGE'
export const UNREAD_MESSAGE_COUNT = 'UNREAD_MESSAGE_COUNT'

export const showLoader = () => ({type: SHOW_LOADER})

export const hideLoader = () => ({type: HIDE_LOADER})

export const haveUnreadMessages = haveUnreadMessages => ({type: HAVE_UNREAD_MESSAGES, haveUnreadMessages})

export const haveNewMessage = haveNewMessage => ({type: HAVE_NEW_MESSAGE, haveNewMessage})
